













































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class HowToCharacter extends Vue {
  modalOpen = false;
  openModal(): void {
    this.modalOpen = true;
    console.log('Show Video');
  }

  closeModal(): void {
    this.modalOpen = false;
  }
}
